import { useEffect, useRef } from 'react';
import { Button } from '@optimus-web/core';
import { lt, useDialog } from '@mews/framework';
import { AddBillDialog } from '../../../billing/BillNameDialog/AddBillDialog';

interface NewBillButtonProps {
    accountId: string;
}
export const CustomerAddBill: React.FC<NewBillButtonProps> = ({ accountId }) => {
    const [{ onClose, active }, toggleDialog] = useDialog();

    const timeoutRef = useRef<number | null>(null);

    useEffect(
        () => () => {
            if (timeoutRef.current) {
                window.clearTimeout(timeoutRef.current);
            }
        },
        []
    );

    return (
        <>
            <AddBillDialog active={active} onClose={onClose} accountId={accountId} />
            <Button variant="primary" onClick={toggleDialog} type="submit">
                {lt('AddBill')}
            </Button>
        </>
    );
};
